var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLabel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 28.7,
    cy: 14.6,
    r: 2.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M13.8 34.3l-4.7-4.7c-2-2-2-5.2 0-7.2L23 8.5l11.6-.2.3 12.2L21 34.3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M15.4 23l4.9 4.9M19.3 18.8l4.9 4.9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabel);
export default __webpack_public_path__ + "static/media/label.d25d50fe6b4506a05b1887991212f038.svg";
export { ForwardRef as ReactComponent };